import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './style/theme/index.css';
import moment from 'moment';
import store from './store/store';
import router from './router';
import './utils/gt';
import "./style/common.css";
import App from './App';
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$moment = moment;
moment.locale('zh-cn');
//swiper轮播
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper);
//aos动画库
import 'aos/dist/aos.css'
import AOS from 'aos/dist/aos.js'
import BaiduMap from 'vue-baidu-map';

Vue.use(BaiduMap,{
  ak: 'iWKSYo6n5AWGrNzp9QqVzSQMpiigejWa',
})

AOS.init({
  offset: 200,
  duration: 600,   //持续时间
  easing: 'ease-in-sine',
  delay: 100
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});

// 跳转后自动返回页面顶部
router.afterEach(() => {window.scrollTo(0,0);
})



// WEBPACK FOOTER //
// ./src/main.js